const NativeResizeObserver = window.ResizeObserver

if (NativeResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor (callback) {
      let frame = null

      super((entries, observer) => {
        if (frame) {
          window.cancelAnimationFrame(frame)
        }

        frame = window.requestAnimationFrame(() => {
          frame = null
          callback(entries, observer)
        })
      })
    }
  }
}
